import React from 'react';
import loadable from '@loadable/component';
import { ErrorBoundary } from 'components/Errors';
import Loader from 'components/Loader';

const Contact = loadable(() => import(/* webpackChunkName: "Contact" */ './Contact'), {
  fallback: <Loader visible />,
});

const AsyncContact = () => (
  <ErrorBoundary>
    <Contact />
  </ErrorBoundary>
);

export default AsyncContact;
